import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/reducers';
import { HeldInReservePageState, PayoutTxnsPageState } from './payouts.model';
import {
  HELD_IN_RESERVE_DATE_OPTIONS,
  HeldInReserveStatus,
  PAYOUT_TXNS_AMOUNT_FILTERS,
  PAYOUT_TXNS_HELD_IN_RESERVE_TABS,
  PAYOUT_TXNS_TABS,
  PAYOUT_TXNS_TYPE_FILTERS
} from './constants';

interface PayoutsSliceState {
  payoutTxnsFilters: PayoutTxnsPageState;
  heldInReserveFilters: HeldInReservePageState;
}

export const initialPayoutTxnsPageState = {
  amountFilter: { title: '', min: '', max: '' },
  search: '',
  typeFilter: [PAYOUT_TXNS_TYPE_FILTERS.COLLECTED, PAYOUT_TXNS_TYPE_FILTERS.REFUNDS],
  tab: PAYOUT_TXNS_TABS.PAYMENTS
};

export const initialHeldInReservePageState: HeldInReservePageState = {
  amount: { title: PAYOUT_TXNS_AMOUNT_FILTERS.ALL, min: '', max: '' },
  transactionId: '',
  status: HeldInReserveStatus.HELD,
  createdDateFilter: { option: HELD_IN_RESERVE_DATE_OPTIONS.CREATED.ALL, startDate: '', endDate: '' },
  availableDateFilter: { option: HELD_IN_RESERVE_DATE_OPTIONS.AVAILABLE.ALL, startDate: '', endDate: '' },
  tab: PAYOUT_TXNS_HELD_IN_RESERVE_TABS.TO_BE_RELEASED
};

const initialState: PayoutsSliceState = {
  payoutTxnsFilters: initialPayoutTxnsPageState,
  heldInReserveFilters: initialHeldInReservePageState
};

export const payoutsSlice = createSlice({
  name: 'payouts',
  initialState,
  reducers: {
    resetPayoutState: () => initialState,
    setPayoutTransactionFilters: (state, { payload }: PayloadAction<PayoutTxnsPageState>) => {
      state.payoutTxnsFilters = { ...payload };
    },
    setHeldInReserveFilters: (state, { payload }: PayloadAction<HeldInReservePageState>) => {
      state.heldInReserveFilters = { ...payload };
    }
  }
});

export const { setPayoutTransactionFilters, resetPayoutState, setHeldInReserveFilters } = payoutsSlice.actions;

export const selectPayoutTxnsFilters = (state: RootState) => state.rootReducer.payouts.payoutTxnsFilters;
export const selectHeldInReserveFilters = (state: RootState) => state.rootReducer.payouts.heldInReserveFilters;

export default payoutsSlice.reducer;
